<ng-container>&lrm;{{value | signedNumber:digitsInfo}}</ng-container>
